import { useContext } from 'react';
import { AppContext } from '../../../../common/context/Provider';
import { UseChangeWebPageTitle } from '../../../../common';
import { WorkshiftScheduler } from '../../../../common/components/Workshift-scheduler/Index';

export default function Home() {
    const { langResources } = useContext(AppContext);

    const { nameOfWebPage } = UseChangeWebPageTitle(
        langResources['web.pages.titles']['home.page']
    );

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row '>
                        <div className='col-12 p-0'>
                            <WorkshiftScheduler />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
